module.exports = __webpack_public_path__ + "img/W7007-full.59e4d409.jpg";